// extracted by css-extract-rspack-plugin
module.exports =  {"container":"LearningText-wt4E__container"};